export const nullFn = () => null
